<template>
  <div class="fans">
    <van-nav-bar
      title="客服"
      fixed
      placeholder
      :border="false"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="fans_block">
      <div class="fans_block_list" @click="kfbtn">
        <img
          class="fans_block_list_kefu"
          src="../../assets/images/licai/kefu.png"
        />
        <p class="">在线客服</p>
        <img class="right" src="../../assets/images/licai/right.png" />
      </div>
      <div class="fans_block_list">
        <img
          class="fans_block_list_kefu"
          src="../../assets/images/licai/rexian.png"
        />
        <p class="">400-658-6612</p>
        <img class="right" src="../../assets/images/licai/right.png" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      types: 1,
      lists: 1,
      items: 1
    };
  },
  mounted: function() {},
  methods: {
    kfbtn() {
      this.$router.push({
        path: "/customerService"
      });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    fans(type) {
      this.types = type;
    },
    vips(list) {
      this.lists = list;
    },
    hhh(item) {
      this.items = item;
    }
  }
};
</script>

<style scoped>
.fans {
  width: 100%;
}
.fans_top {
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 18px;
}
.fans_block_list {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  margin-top: 15px;
}
.fans_block_list p {
  font-size: 18px;
  margin-left: 20px;
}
.fans_block_list_kefu {
  width: 30px;
  height: 30px;
}
.right {
  width: 20px;
  height: 23px;
  margin-left: auto;
}
</style>

